import React, { Fragment, useRef } from "react";
import ColorPicker from "material-ui-color-picker";
import Loader from "../../common/Loader"
import { FONT_FAMILY } from '../../constant/bannerItems'
import DeleteIcon from '@material-ui/icons/Delete';
import { List, makeStyles, ListItem, ListItemText, ListItemSecondaryAction, TextField, Button, FormControl, Select, MenuItem } from "@material-ui/core";
import JoditEditor from "jodit-react";
import TextEditorConfig from "../../helpers/TextEditor";

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		maxWidth: 600,
		backgroundColor: theme.palette.background.paper,
	},
	createUser: {
		width: '100%',
		maxWidth: 800,
	},
	textField: {
		width: '40ch',
	}
}));

const PromotionalProductCatDayForm = ({ proCatId, isLoading, handleClose, inputs, handleInputChange, handleColorPicker, handleFileInputChange, handleSubmit, errors, fromEditAction, deleteImage, tempImage, setImage, resetColor }) => {

	const classes = useStyles();
	const editor = useRef(null)
	const errorClass = {
		color: "red",
	}

	const onSubmit = () => {
		handleSubmit()
	}

	return (
		<Fragment>
			{isLoading && (
				<Loader />
			)}
			<div className="banner-form" style={{ 'minHeight': '50vh' }}>
				<form className="banner-form-style" >
					<List>
						{fromEditAction === 'btn' && (
							<>
								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Button Text" />
									<ListItemSecondaryAction>
										<TextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.btnText}
											onChange={handleInputChange}
											name="btnText"
										/>
									</ListItemSecondaryAction>
								</ListItem>
								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Link" />
									<ListItemSecondaryAction>
										<TextField
											id="outlined-basic"
											label=""
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.link}
											onChange={handleInputChange}
											name="link"
										/>
									</ListItemSecondaryAction>
								</ListItem>
								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Button Bg color" />
									<div className="col-lg-3">
										<ColorPicker
											name="btnBgColor"
											defaultValue="#000"
											value={inputs.btnBgColor}
											onChange={color => { handleColorPicker('btnBgColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0">{inputs.btnBgColor != undefined && (inputs.btnBgColor)}</p>
										{inputs.btnBgColor != undefined &&
											inputs.btnBgColor != "undefined" &&
											inputs.btnBgColor != "" && (<DeleteIcon
												className="text-error  ml-4"
												title={"Delete"}
												onClick={() => {
													resetColor("", 'btnBgColor')
												}}
												aria-label=""
											/>)}
									</div>
								</ListItem>

								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Button Text Color" />
									<div className="col-lg-3">
										<ColorPicker
											name="btnTextColor"
											defaultValue="#000"
											value={inputs.btnTextColor}
											onChange={color => { handleColorPicker('btnTextColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0">{inputs.btnTextColor != undefined && (inputs.btnTextColor)}</p>
										{inputs.btnTextColor != undefined &&
											inputs.btnTextColor != "undefined" &&
											inputs.btnTextColor != "" && (<DeleteIcon
												className="text-error ml-4"
												title={"Delete"}
												onClick={() => {
													resetColor("", 'btnTextColor')
												}}
												aria-label=""
											/>)}
									</div>
								</ListItem>


								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Button Hover Color" />
									<div className="col-lg-3">
										<ColorPicker
											name="btnBgHoverColor"
											defaultValue="#000"
											value={inputs.btnBgHoverColor}
											onChange={color => { handleColorPicker('btnBgHoverColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0">{inputs.btnBgHoverColor != undefined && (inputs.btnBgHoverColor)}</p>
										{inputs.btnBgHoverColor != undefined &&
											inputs.btnBgHoverColor != "undefined" &&
											inputs.btnBgHoverColor != "" && (<DeleteIcon
												className="text-error ml-4"
												title={"Delete"}
												onClick={() => {
													resetColor("", 'btnBgHoverColor')
												}}
												aria-label=""
											/>)}
									</div>
								</ListItem>

								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Button Hover Text Color" />
									<div className="col-lg-3">
										<ColorPicker
											name="btnTextHoverColor"
											defaultValue="#000"
											value={inputs.btnTextHoverColor}
											onChange={color => { handleColorPicker('btnTextHoverColor', color) }}
										/>
									</div>
									<div className="col-lg-3 d-flex align-items-center">
										<p className="m-0">{inputs.btnTextHoverColor != undefined && (inputs.btnTextHoverColor)}</p>
										{inputs.btnTextHoverColor != undefined &&
											inputs.btnTextHoverColor != "undefined" &&
											inputs.btnTextHoverColor != "" && (<DeleteIcon
												className="text-error ml-4"
												title={"Delete"}
												onClick={() => {
													resetColor("", 'btnTextHoverColor')
												}}
												aria-label=""
											/>)}
									</div>
								</ListItem>
							</>
						)}
						{fromEditAction === 'title' && (
							<>
								<ListItem className="mb-35">
								<div className="row w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Title" />
									</div>
									<div className="col-lg-9">
										<JoditEditor
											ref={editor}
											value={inputs.title}
											config={TextEditorConfig}
											className={classes.textField}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.title = bodyOfEditor
												
											}}
										/>
									</div>
								</div>
								</ListItem>
								
							</>
						)}

						{fromEditAction === 'description' && (
							<>
								<ListItem className="mb-35">
								<div className="row w-100">
									<div className="col-lg-3">
										<ListItemText id="switch-list-label-wifi" primary="Description" />
									</div>
									<div className="col-lg-9">										
										<JoditEditor
											ref={editor}
											value={inputs.description}
											config={TextEditorConfig}
											className={classes.textField}
											tabIndex={1}
											onChange={(bodyOfEditor) => {
												inputs.description = bodyOfEditor
												
											}}
										/>
									</div>
								</div>
								</ListItem>
							</>
						)}

						{fromEditAction === 'bgImg' && (
							<>
								<ListItem className="mb-60">
									<ListItemText id="switch-list-label-wifi" primary="Image Height" />
									<ListItemSecondaryAction>
										<TextField
											id="standard-number"
											type="number"
											InputLabelProps={{
												shrink: true
											}}
											size="medium"
											variant="outlined"
											fullWidth
											className={classes.textField}
											value={inputs.imageHeight}
											onChange={handleInputChange}
											name="imageHeight"
											error={errors && errors.imageHeight ? true : false}
											helperText={errors && errors.imageHeight ? errors.imageHeight : ""}
										/>PX
									</ListItemSecondaryAction>
								</ListItem>
								<ListItem className="mb-35">
									<ListItemText id="switch-list-label-wifi" primary="Product Category Image" />
									<div className="col-lg-5">
										<input onChange={handleFileInputChange}
											type="file"
											name="productImage"
										/>
									</div>

									<div className="col-lg-3">
										{tempImage && (<>
											<img height="50px" width="50px" src={tempImage}></img>
											<DeleteIcon
												className="text-error"
												title={"Delete"}
												onClick={() => {
													setImage("", 'productImage')
													deleteImage()
												}}
												aria-label=""
											/></>)}
									</div>
								</ListItem>
							</>
						)}

						<ListItem>
							<button type="button" className="cancelButton" onClick={() => { handleClose() }}>Cancel</button>&nbsp;&nbsp;&nbsp;
							<Button variant="contained" color="primary" className="bannerbutton" type="button" onClick={() => { onSubmit() }}> {proCatId ? "Update" : "Save"}</Button>

						</ListItem>
					</List>

				</form>
			</div>
		</Fragment>
	);
};

export default PromotionalProductCatDayForm;
